import React from 'react';
import { Box, Paper, useTheme } from '@mui/material';
import { useSelector } from 'react-redux';
import FileUploader from './FileUploader';

const EnhancedEmptyState = ({ onUpload }) => {
  const theme = useTheme();
  const { isAuthenticated } = useSelector((state) => state.auth);
  
  const handleUploadComplete = (files, language, certification_type = 'none', is_urgent = false) => {
    // 如果用户未登录，触发登录检查（点击拖放区域时）
    if (!isAuthenticated && (!files || !language)) {
      onUpload(); // 触发登录弹窗，无参数表示点击触发
      return;
    }
    
    // 如果已登录且有文件和语言参数，进行实际上传
    if (isAuthenticated && files && language) {
      onUpload(files, language, certification_type, is_urgent); // 传递四个参数，包括加急标志
      return;
    }
  };
  
  return (
    <Box sx={{ p: 2, height: '750px' }}>
      <FileUploader 
        onComplete={handleUploadComplete}
        isDialog={false}
        requireAuth={!isAuthenticated}
      />
    </Box>
  );
};

export default EnhancedEmptyState;